export default "__VITE_ASSET__CCLbG5fW__"